import { Routes } from '../api-routes'
import { Traceable } from '../dtos/assistant'
import { CaseWorkerDTO } from '../dtos/caseWorker'
import { Language, OrganizationDTO } from '../dtos/organization'
import {
  StructuredDataDisplayDTO,
  StructuredDataSchemaDTO,
  UpdateStructuredDataDisplayDTO,
  UpdateStructuredDataSchemaDTO,
} from '../dtos/structured-data'
import { getPath, setP } from './helpers'

// === STRUCTURED DATA SCHEMA ===
export class GetStructuredDataSchema {
  static getPath(p = setP(['organizationId'])) {
    return getPath(p, { suffix: 'structured-data/schema' })
  }
  static response: StructuredDataSchemaDTO
}
export class UpdateStructuredDataSchema {
  static getPath(p = setP(['organizationId'])) {
    return getPath(p, { suffix: 'structured-data/schema' })
  }
  static request: UpdateStructuredDataSchemaDTO
  static response: { success: true }
}

// === STRUCTURED DATA DISPLAY ===
export class GetStructuredDataDisplay {
  static getPath(p = setP(['organizationId'])) {
    return getPath(p, { suffix: 'structured-data/display' })
  }
  static response: StructuredDataDisplayDTO
}
export class UpdateStructuredDataDisplay {
  static getPath(p = setP(['organizationId'])) {
    return getPath(p, { suffix: 'structured-data/display' })
  }
  static request: UpdateStructuredDataDisplayDTO
  static response: { success: true }
}

export namespace OrganizationsRoutes {
  export namespace createOneFromAssistant {
    export function call() {
      return `/${Routes.Organizations}/${Routes.Onboarding}/createOrganization`
    }
    export type Request = {
      language: Language
      name: string
      url?: string
    }
    export type Response = {
      caseWorker: CaseWorkerDTO
      organization: OrganizationDTO
    }
  }

  export namespace generateOrganizationDescription {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, {
        suffix: 'generate/description',
      })
    }
    export type Response = { description: string } & Traceable
  }

  export namespace generateOrganizationMethodology {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, {
        suffix: 'generate/methodology',
      })
    }
    export type Response = { methodology: string } & Traceable
  }

  export namespace patchOne {
    export function call(p = setP(['organizationId'])) {
      return getPath(p)
    }
    export type Request = {
      fields: Partial<
        Pick<
          OrganizationDTO,
          | 'categoriesSettings'
          | 'chatAnswerGoal'
          | 'chatAssistantName'
          | 'chatMessageInstructions'
          | 'chatSafetyRules'
          | 'chatSettings'
          | 'commonSources'
          | 'description'
          | 'methodology'
          | 'name'
          | 'onboarding'
          | 'texts'
          | 'url'
        >
      >
    }
    export type Response = { organization: OrganizationDTO }
  }

  export namespace get {
    export function call() {
      return `/${Routes.Organizations}`
    }
    export type Response = { organizations: OrganizationDTO[] }
  }

  export namespace getOne {
    export function call(p = setP(['organizationId'])) {
      return getPath(p)
    }
    export type Response = { organization: OrganizationDTO }
  }
}
